"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var endsWith_1 = __importDefault(require("./helpers/endsWith"));
var stripUnit_1 = __importDefault(require("./helpers/stripUnit"));
exports.default = (function (pxval, base) {
    if (base === void 0) { base = '16px'; }
    var to = 'rem';
    var newPxval = pxval;
    var newBase = base;
    if (typeof pxval === 'string') {
        if (!endsWith_1.default(pxval, 'px')) {
            throw new Error('Expected a value in string ending in "px"');
        }
        newPxval = stripUnit_1.default(pxval);
    }
    if (typeof base === 'string') {
        if (!endsWith_1.default(base, 'px')) {
            throw new Error('Expected a base value in string ending in "px"');
        }
        newBase = stripUnit_1.default(base);
    }
    if (typeof newPxval === 'string') {
        throw new Error('Passed invalid pixel value for value.');
    }
    if (typeof newBase === 'string') {
        throw new Error('Passed invalid base value for base.');
    }
    return "" + newPxval / newBase + to;
});
//# sourceMappingURL=rem.js.map